export * from "./DoctorDetails.async";
